import styled from 'styled-components';

const FamilyWrapper = styled.div`
.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    background: #34C759 !important;
}
.switch-text {
    font-family: Bliss2;
    font-weight: 700;
    font-size: 16px;
    color: #4C565C;
    margin-top: 2px;
    margin-left: 10px;
}
.switch-text-rtl {
    font-family: Bliss2;
    font-weight: 700;
    font-size: 16px;
    color: #4C565C;
    margin-top: 2px;
    margin-right: 10px;
}
.title {
    font-family: Bliss2;
    font-weight: 800;
    font-size: 22px;
    line-height: 26px;
    text-transform: capitalize;
    color: #6B47F5;
    margin: 24px 0px;
    text-align: initial;
}
.title-rtl {
    font-family: Bliss2;
    font-weight: 800;
    font-size: 22px;
    line-height: 26px;
    text-transform: capitalize;
    color: #6B47F5;
    margin: 24px 0px;
    text-align: right;
}
.p-button.p-component {
    background: #6B47F5;
    border-radius: 5px;
    height: 44px;
    padding: 10px 18px;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-transform: uppercase;
    border-color: #6B47F5;
    box-shadow: none;
}

`;

export default FamilyWrapper;